import script from "./SButtonConfirm.vue?vue&type=script&setup=true&lang=js"
export * from "./SButtonConfirm.vue?vue&type=script&setup=true&lang=js"

import "./SButtonConfirm.vue?vue&type=style&index=0&id=edd67882&scoped=true&lang=scss"

import exportComponent from "/home/deployer/deploypad/silogues/releases/20261022152544/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-edd67882"]])

export default __exports__